import { useState, useMemo } from 'react';
import _ from 'lodash';

export function useCertificateTable() {
    const [tableState, setTableState] = useState();
    const [selection, setSelection] = useState();

    const actionsDisabled = useMemo(() => {
        if (!selection) return true;
        return _.isEmpty(selection.selection) && !selection.inverted;
    }, [selection]);

    return {
        tableState,
        setTableState,
        selection,
        setSelection,
        actionsDisabled,
    };
}
